import { Injectable } from "@angular/core";
import { Circulation, IMetaData } from "../interfaces";
import { LogClass } from "../logger";

@LogClass({ source: "CirculationMetadataService" })
@Injectable({
  providedIn: "root"
})
export class CirculationMetadataService {
  public getEditableMetadata(c: Circulation): IMetaData[] {
    return (c.props.payload?.data || []).filter((item) => {
      return !item.settings?.isReadonly || false;
    });
  }

  public getVisibleMetadata(c: Circulation): IMetaData[] {
    return (c.props.payload?.data || []).filter((item) => {
      return item.settings?.isVisibleInUi || false;
    });
  }
}
